import {ItemCreationForm, ServiceFields} from '../../../model/NewItemInput'
import {Header} from '../../../../genericComponents/typographie/UIKitV2/Header'
import {BodySmall} from '../../../../genericComponents/typographie/UIKitV2/BodySmall'
import '../../genericComponents/formTemplate/ServiceRequestFormTemplate.scss'
import './NewManufacturerItemsConfirmation.scss'
import {ROUTES} from '../../../../constants/routing'
import {Link, useLocation} from 'react-router-dom'
import {useDatxPathGenerator} from '../../../../util/routing'
import { FieldSummary, ProofSummary } from '../common/Confirmation'

export const NewManufacturerItemsConfirmation = ({serviceDetails, requestId}: {
    serviceDetails?: ItemCreationForm,
    requestId?: string,
}) => {

    const generatePath = useDatxPathGenerator()
    const {pathname} = useLocation()
    const itemType = pathname?.includes('hardware') ? 'Hardware'
        : pathname?.includes('chemical') ? 'Chemical' : pathname?.includes('software') ? 'Software' : ''

    if (!itemType || !serviceDetails || !requestId) return <></>

    return <div className="service-request-confirmation">
        <Header>Your request has been sent for validation.</Header>
        <BodySmall>Request ID: <strong data-testid="requestId">{requestId}</strong></BodySmall>
        <div>
            <BodySmall>This service is a commercial process requiring interaction with the DATX commercial
                team.</BodySmall>
            <BodySmall>After your request is approved a DATX representative will contact you soon on your
                request.</BodySmall>
        </div>
        <BodySmall>You may track your request on the <Link data-testid="myRequestLink"
                                                           to={generatePath(ROUTES.userServiceRequests.path)}>My
            Request</Link> page.</BodySmall>
        <BodySmall>Please find below your request resume:</BodySmall>
        <div className="divider"></div>

        <div data-testid="manufacturer-item-creation-summary" className="service-request-form-summary">
            <FieldSummary label="Part Number" value={serviceDetails?.partNumber}/>
            <FieldSummary label="Technical Classification"
                          value={serviceDetails?.technicalClassificationNode?.label}/>
            <FieldSummary label="Defined by" value={serviceDetails?.definedByOrganization?.label}/>

            <ProofSummary label="Evidence Documents" values={serviceDetails[ServiceFields.EvidenceDocuments].proofs}/>

            <FieldSummary label="End of Life Status" value={serviceDetails[ServiceFields.EndOfLifeStatus]?.date}/>
            <ProofSummary label="Proof for End of Life Status"
                          values={serviceDetails[ServiceFields.EndOfLifeStatus]?.proofs ?? []}/>

            <FieldSummary label="Export Control Classification"
                          value={serviceDetails[ServiceFields.ExportControlClassification]?.type}/>
            <ProofSummary label="Proof for Export Control Classification"
                          values={serviceDetails[ServiceFields.ExportControlClassification]?.proofs ?? []}/>

            {serviceDetails[ServiceFields.EnvironmentalRegulation].length > 0 ?
                serviceDetails[ServiceFields.EnvironmentalRegulation].map((envReg, i) => <>
                        <FieldSummary label="Environmental Compliance"
                                      value={serviceDetails[ServiceFields.EnvironmentalRegulation][i]?.type}/>
                        <ProofSummary label="Proof for Environmental Compliance"
                                      values={serviceDetails[ServiceFields.EnvironmentalRegulation][i].proofs}/>
                    </>
                ) : <FieldSummary label="Environmental Compliance"/>

            }

        </div>
    </div>
}
